// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splashGradient {
  background: rgb(36, 46, 19);
  background-image: url('heroImage2.02e26391cef7ebe4.png'), linear-gradient(360deg, rgb(36, 46, 19) 0%, rgb(102, 129, 56) 26%);
}

.spacer {
  flex: 1 1 auto;
}

.login-container {
  height: calc(100vh - 64px) !important;
  background-color: #cccccc;
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100vw;
}

.mr16 {
  margin-right: 16px;
}

.mr30 {
  margin-right: 30px;
}

@media only screen and (max-width: 959px) {
  .login-container {
    height: calc(100vh - 64px) !important;
    background-color: #cccccc;
    background-position: top;
    background-repeat: no-repeat;
    background-size: 170vw, 170vh;
  }
}
@media only screen and (max-width: 599px) {
  .login-container {
    height: calc(100vh - 56px) !important;
    background-color: #cccccc;
    background-position: top;
    background-repeat: no-repeat;
    background-size: 300vw, 100vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/kiosk-page/kiosk-page.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,4HAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,qCAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI;IACI,qCAAA;IACA,yBAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;EACN;AACF;AAEA;EACI;IACI,qCAAA;IACA,yBAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;EAAN;AACF","sourcesContent":[".splashGradient {\r\n    background: rgb(36,46,19);\r\n    background-image: url(\"../../../../assets/heroImage2.png\"), linear-gradient(360deg, rgba(36,46,19,1) 0%, rgba(102,129,56,1) 26%);\r\n}\r\n\r\n.spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.login-container {\r\n    height: calc(100vh - 64px) !important;\r\n    background-color: #cccccc;\r\n    background-position: top;\r\n    background-repeat: no-repeat;\r\n    background-size: 100vw;\r\n}\r\n\r\n.mr16 {\r\n    margin-right: 16px;\r\n}\r\n\r\n.mr30 {\r\n    margin-right: 30px;\r\n}\r\n\r\n@media only screen and (max-width: 959px) {\r\n    .login-container {\r\n        height: calc(100vh - 64px) !important;\r\n        background-color: #cccccc;\r\n        background-position: top;\r\n        background-repeat: no-repeat;\r\n        background-size: 170vw, 170vh;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n    .login-container {\r\n        height: calc(100vh - 56px) !important;\r\n        background-color: #cccccc;\r\n        background-position: top;\r\n        background-repeat: no-repeat;\r\n        background-size: 300vw, 100vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
